import { Alert, Col, Row } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ErrorItem,
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  ModalItem,
  SelectInsumosItem,
  TextAreaItem,
} from "../../../../Components/Items";

// Renglón sin factura: mercancía que se le regresa al proveedor pero que no se puede ligar a
// una factura o remisión del sistema (por ejemplo, una compra anterior al sistema). Sirve
// para reemplazo, reparación o rechazo, pero no para nota de crédito ligada a factura.
class ModalRenglonLibreRMACompra extends Component {
  formRef = React.createRef();
  insumoElegido = null;

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.insumoElegido = null;
      this.formRef.current?.resetFields();
    }
  }

  async agregar() {
    let valores;
    try {
      valores = await this.formRef.current.validateFields();
    } catch (e) {
      return ErrorItem(e);
    }
    this.props.onAgregar({
      libre: true,
      insumoId: valores.insumoId || undefined,
      codigo: this.insumoElegido?.codigo !== undefined ? String(this.insumoElegido.codigo) : "",
      descripcion: (valores.descripcion || "").trim(),
      cantidadSolicitada: Number(valores.cantidadSolicitada) || 0,
      precioUnitarioNeto: Number(valores.precioUnitarioNeto) || 0,
      factorImpuestos: 1,
      tipoDeCambio: 1,
      observaciones: valores.observaciones || "",
    });
  }

  render() {
    return (
      <ModalItem
        title="Agregar renglón sin factura"
        visible={this.props.visible}
        onCancel={this.props.onCerrar}
        onOk={this.agregar.bind(this)}
        okText="Agregar al RMA"
        footer
        width={window.innerWidth > 1000 ? 640 : "95%"}
        paddingTop
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message="Un renglón sin factura no puede llevar nota de crédito ligada a una factura: solo reemplazo, reparación o rechazo."
        />
        <Form ref={this.formRef} name="renglonLibreRMACompra" layoutForm="vertical">
          <FormItem label="Insumo (opcional)" name="insumoId" margin>
            <SelectInsumosItem
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              placeholder="Busca el insumo si existe en el catálogo"
              width="100%"
              allowClear
              onChange={(insumoId, insumo) => {
                this.insumoElegido = insumo || null;
                this.formRef.current?.setFieldsValue({
                  insumoId,
                  ...(insumo?.descripcion ? { descripcion: insumo.descripcion } : {}),
                });
              }}
            />
          </FormItem>
          <FormItem label="Descripción" name="descripcion" required margin>
            <InputItem placeholder="Qué se le regresa al proveedor" />
          </FormItem>
          <Row gutter={16}>
            <Col xs={12}>
              <FormItem label="Cantidad" name="cantidadSolicitada" required margin>
                <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} />
              </FormItem>
            </Col>
            <Col xs={12}>
              <FormItem
                label="Valor unitario estimado (MXN)"
                name="precioUnitarioNeto"
                tooltip={{ title: "Solo sirve para calcular el monto que se le reclama al proveedor." }}
                margin
              >
                <InputNumberItem placeholder="0.00" min={0} dinero style={{ width: "100%" }} />
              </FormItem>
            </Col>
          </Row>
          <FormItem label="Falla" name="observaciones" margin>
            <TextAreaItem rows={2} placeholder="Número de serie, qué falla, estado en que está, etc." />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalRenglonLibreRMACompra);
